import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToHash } from "./utils/scrollToHash";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    scrollToHash();
  }, [location]);

  return null;
}
